import React from "react";

import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FiTrash2 } from "react-icons/fi";

import { useAppState } from "../../../../../../../context/StateContext";
import { Color } from "../../../../../../../components/Form/Button";
import { GroupButtons, GroupedButtons } from "../../../../../../../components/Generic/GroupedButtons";
import useStyles from "./styles";

interface ProductActionsButtonsProps {
  leftPanelSelected: string;
  validateAndSaveProduct: () => void;
  onCancel: () => void;
  onDelete: () => void;
  loading: boolean;
  viewOnly: boolean;
  productAlreadySubmitted: boolean;
  productId?: number;
}

const ProductActionsButtons = (props: ProductActionsButtonsProps) => {
  const {
    validateAndSaveProduct,
    onCancel,
    onDelete,
    loading,
    viewOnly,
    productId,
    productAlreadySubmitted,
  } = props;
  const classes = useStyles();
  const { t: translate } = useTranslation();
  const { isFMVersion } = useAppState();

  const save = () => {
    return () => validateAndSaveProduct();
  };

  return (
    <Box
      className={classes.buttons}
      display="flex"
      flexDirection={"row"}
      justifyContent={"space-between"}
    >
      <Box
        display="flex"
        flexDirection={"row"}
        justifyContent={"flex-start"}
        className={classes.buttons}
      >
        <GroupedButtons
          buttons={
            [
              ...(productId
                ? [
                  {
                    name: "deleteProduct",
                    action: onDelete,
                    disabled: viewOnly || loading,
                    variant: "text",
                    customColor: Color.ERROR,
                    text: translate("deleteProduct"),
                    startIcon: <FiTrash2 size={18} color="#fff" />,
                    loading,
                  },
                ]
                : []),
            ] as GroupButtons[]
          }
        />
      </Box>
      <Box
        display="flex"
        flexDirection={"row"}
        justifyContent={"flex-end"}
        className={classes.buttons}
      >
        <GroupedButtons
          buttons={[
            {
              name: "cancel",
              action: onCancel,
              disabled: loading,
              variant: "text",
              customColor: Color.CANCEL,
              text: translate("cancel"),
            },
            {
              name: "save",
              action: save(),
              disabled: viewOnly || (productAlreadySubmitted && !isFMVersion),
              loading,
              className: isFMVersion ? undefined : classes.saveAndBook,
              customColor: Color.SUCCESS,
              text: !productId ? translate("create") : translate("save"),
            },
          ]}
        />
      </Box>
    </Box>
  );
};

export default ProductActionsButtons;
